// tslint:disable: no-input-rename no-output-rename

import { Input, TemplateRef, Directive, HostListener, EventEmitter, Output, OnDestroy } from '@angular/core';
import { ModalService, ModalConfig } from './modal.service';
import { Subscription } from 'rxjs';

const PRIMARY_ACTION_TAG = 'primaryAction';
const SECONDARY_ACTION_TAG = 'secondaryAction';

@Directive({
  selector: '[sukaModal]'
})
export class ModalDirective {
  constructor(protected modalService: ModalService) { }

  @Input('modalCloseButton') closeButton = false;
  @Input('modalTitle') title: string | TemplateRef<any>;
  @Input('modalBody') body: string | TemplateRef<any>;
  @Input('modalCloseOnBackdropClick') closeOnBackdropClick = true;

  @Output('modalClose') close = new EventEmitter();

  @Input('modalSecondaryActionLabel') secondaryActionLabel: string;
  @Output('modalSecondaryAction') secondaryAction = new EventEmitter();

  @Input('modalPrimaryActionLabel') primaryActionLabel: string;
  @Output('modalPrimaryAction') primaryAction = new EventEmitter();

  @HostListener('click')
  onClick() {
    this.openModal();
  }

  private openModal() {
    const modalConfig: ModalConfig = {
      closeOnBackdropClick: this.closeOnBackdropClick,
      content: {
        closeButton: this.closeButton,
        title: this.title,
        body: this.body,
      }
    };

    if (this.primaryActionLabel || this.secondaryActionLabel) {
      modalConfig.content.actions = [];

      if (this.primaryActionLabel) {
        modalConfig.content.actions.push({
          label: this.primaryActionLabel,
          type: 'primary',
          tag: PRIMARY_ACTION_TAG
        });
      }

      if (this.secondaryActionLabel) {
        modalConfig.content.actions.push({
          label: this.secondaryActionLabel,
          type: 'secondary',
          tag: SECONDARY_ACTION_TAG
        });
      }
    }

    const modalRef = this.modalService.open(modalConfig);

    modalRef.afterClosed().subscribe((result: any) => {
      switch (result) {
        case PRIMARY_ACTION_TAG:
          if (this.primaryAction.observers.length > 0) {
            this.primaryAction.emit(result);
          }
          break;
        case SECONDARY_ACTION_TAG:
          if (this.secondaryAction.observers.length > 0) {
            this.secondaryAction.emit(result);
          }
          break;
        default:
          if (this.close.observers.length > 0) {
            this.close.emit();
          }
          break;
      }
    });
  }
}
